// extracted by mini-css-extract-plugin
export var links = "links-module--links--bf1c8";
export var sectionTitle = "links-module--sectionTitle--e93a2";
export var social = "links-module--social--2dfbe";